import { css } from '@emotion/react';

import streamChatCss from '@/styles/streamChat';
import typographyCss from '@/styles/typography';
import classNamesCss from '@/styles/utils/classNames';
import variablesFigma from '@/styles/variablesFigma';

// Removed the direct import of ionicCss to prevent it from being applied globally

export const globalStyles = css`
  ${variablesFigma}

  body {
    font-family: 'Matter', sans-serif;
    font-style: normal;
    font-weight: 400;
    letter-spacing: -0.01em;
    color: var(--figma-color-darkgray-300);
    background-color: var(--figma-color-neutral-200);
  }

  a {
    color: var(--figma-color-darkgray-300);

    &:hover {
      color: var(--figma-color-darkgray-200);
    }
  }

  #root {
    height: 100%;
  }

  ${typographyCss}
  ${streamChatCss}
  ${classNamesCss}
`;
